function getImageUri(imageArray, imageNumber) {
    if (imageArray && imageArray.length) {
        if (
            imageNumber &&
            typeof imageNumber === 'number' &&
            imageNumber < imageArray.length &&
            imageNumber > 0
        ) {
            return imageArray[imageNumber].uri;
        }
        return imageArray[0].uri;
    }
    return '';
}

module.exports = {getImageUri};
